export default "__VITE_ASSET__mxHdFa5M__"